import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { CookieProvider } from './contexts/CookieContext';
import { AnalyticsProvider } from './contexts/AnalyticsContext';
import Layout from './components/Layout';
import LoginPage from './components/auth/LoginPage';
import HomePage from './pages/HomePage';
import ArticlesPage from './pages/ArticlesPage';
import VideosPage from './pages/VideosPage';
import ContentPage from './pages/ContentPage';
import WriteArticlePage from './pages/WriteArticlePage';
import UploadVideoPage from './pages/UploadVideoPage';
import CategoryLayout from './components/CategoryLayout';
import RegionalPage from './pages/RegionalPage';
import TrendingPage from './pages/TrendingPage';
import BookmarksPage from './pages/BookmarksPage';
import ExplorePage from './pages/ExplorePage';
import BugReportPage from './pages/BugReportPage';
import FeatureRequestPage from './pages/FeatureRequestPage';
import FeedbackPage from './pages/FeedbackPage';
import AdvertisePage from './pages/AdvertisePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CareersPage from './pages/CareersPage';
import BlogPage from './pages/BlogPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import PricingPage from './pages/PricingPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import CookieBanner from './components/CookieBanner';

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <ThemeProvider>
          <CookieProvider>
            <AnalyticsProvider>
              <AuthProvider>
                <Routes>
                  <Route path="/login" element={<LoginPage />} />
                  
                  <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/articles" element={<ArticlesPage />} />
                    <Route path="/videos" element={<VideosPage />} />
                    <Route path="/write" element={<WriteArticlePage />} />
                    <Route path="/upload" element={<UploadVideoPage />} />
                    <Route path="/article/:id" element={<ContentPage />} />
                    <Route path="/video/:id" element={<ContentPage />} />
                    <Route path="/category/:categorySlug" element={<CategoryLayout />} />
                    <Route path="/category/:categorySlug/:subcategorySlug" element={<CategoryLayout />} />
                    <Route path="/regional" element={<RegionalPage />} />
                    <Route path="/trending" element={<TrendingPage />} />
                    <Route path="/bookmarks" element={<BookmarksPage />} />
                    <Route path="/explore" element={<ExplorePage />} />
                    <Route path="/profile/:id" element={<ProfilePage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/bug-report" element={<BugReportPage />} />
                    <Route path="/feature-request" element={<FeatureRequestPage />} />
                    <Route path="/feedback" element={<FeedbackPage />} />
                    <Route path="/advertise" element={<AdvertisePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/careers" element={<CareersPage />} />
                    <Route path="/blog" element={<BlogPage />} />
                  </Route>

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <CookieBanner />
              </AuthProvider>
            </AnalyticsProvider>
          </CookieProvider>
        </ThemeProvider>
      </Router>
    </HelmetProvider>
  );
}